__turbopack_context__.v({
  "container": "styles-module__mN7_dG__container",
  "description": "styles-module__mN7_dG__description",
  "downloadButton": "styles-module__mN7_dG__downloadButton",
  "grabber": "styles-module__mN7_dG__grabber",
  "illustration": "styles-module__mN7_dG__illustration",
  "modal": "styles-module__mN7_dG__modal",
  "qrCode": "styles-module__mN7_dG__qrCode",
  "sheet": "styles-module__mN7_dG__sheet",
  "title": "styles-module__mN7_dG__title",
});
